(function () {
	'use strict';
	$(document).ready(function () {

		function swiperModal() {
		 $('.modal-swiper').each(function () {
				const $this = $(this);

				const swiper = new Swiper($(this)[0], {
					loop: false,
					slidesPerView: 1,
					grid: {
						fill: 'row',
						rows: 2
					},
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: '.swiper-next',
						prevEl: '.swiper-prev',
					},
				});
				swiper.on('slideChange', function () {
					const activeIndex = swiper.activeIndex + 1
					$this.find('.swiper-prev .number').text(`0${activeIndex}`);
				});
			});

		}

		//interactive model
		function getModalData(name) {
			const modalComponent = $('.modal-component');
			const value = `${name}_modal`;
			const data = modal.modalData[value];
			if (data) {
				Object.entries(data).forEach(([key, value]) => {
					$(`#${key}`).html(value);
					if (key === 'slides_third') {
						if (value) {

							let slidesCount = 0;
							value.forEach((slide, index) => {
								if (Object.keys(slide.numbers).length > 2) {
									slidesCount = 2;
								}
							});

							console.log(slidesCount);

							$(`.modal-swiper .swiper-navigation`).remove()
							if(slidesCount > 1){
							$(`.modal-swiper`).prepend(`
								<div class="swiper-navigation swiper-navigation-dark">
									<div class="swiper-prev swiper-button-disabled" tabindex="-1" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-659323b02bcc3ba8" aria-disabled="true">
										<svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.313 1L1 12.112l11.313 11.111" stroke="#BDBDBD" stroke-width="1.5" stroke-linejoin="round"></path></svg><span class="number">01</span>
										</div>
										<span class="line"></span>
										<div class="swiper-next" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-659323b02bcc3ba8" aria-disabled="false">
										<span class="number">0${slidesCount}</span>
									<svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.313 1L1 12.112l11.313 11.111" stroke="#BDBDBD" stroke-width="1.5" stroke-linejoin="round"></path></svg></div>
								</div>
								`);
						}
						value.forEach((slide) => {
							const numbers = slide.numbers;
							if (numbers) {
								numbers.forEach((number) => {
									let unit = '';
									if(number.units) {
										unit = number.units[0].unit;
									}
									$(`#${key}`).append(`
								<div class="swiper-slide">
									<div class="number-component theme-dark text-size--normal with-icon with-units with-value">
										<div class="value-wrapper">
											<div class="value">${number.value}</div>
											<div class="units">
												<span class="unit">
													${unit}
												</span>
											</div>
										</div>
										<div class="caption">${number.caption}</div>
									</div>
								</div>
							`);
								});
							}
						});
						}
					}
					if (key === 'link_third') {
						const target = value.target ?? '_self';
						$(`#${key}`).html(`<a href="${value.url}" target="${target}" class="acf-link button button-brand">${value.title}</a>`);
					}
				});
			}
			swiperModal()
			modalComponent.addClass('open');
		}

		document.querySelectorAll("#clickable a[data-name]").forEach((item) => {
			item.addEventListener('click', function (e) {
				e.preventDefault();
				const name = item.dataset.name;
				getModalData(name);

				const modal = document.querySelector(".modal-swiper");
				modal.swiper.destroy();
				swiperModal();
			});
		});

		function closeModal() {
			const modal = document.querySelector('.modal-component');
			if (modal) {
				modal.classList.remove('open');
			}
		}

		document.querySelector('.close-modal').addEventListener('click', closeModal);

		clickedOutside('.modal-component', function () {
			closeModal();
		}, ['.modal-component', '.model a']);

	});
}(jQuery));
